import { render, staticRenderFns } from "./CompanyAccount.vue?vue&type=template&id=915b1702"
import script from "./CompanyAccount.vue?vue&type=script&lang=js"
export * from "./CompanyAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports